import React from 'react'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../../utils/anchorScroll'

import Logo from './Logo'
import Searchbar from './Searchbar'
import LoggedInHeader from './LoggedInHeader'
import NoAccountModal from './NoAccountModal'
import LoggedOffHeader from './LoggedOffHeader'
import Explore from './Explore'
import isLead from '../../utils/isLead'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons"
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'


const Header = ({ commonStore, location, translationStore }) => {

  return(
    <React.Fragment>
      {/* <Searchbar /> */}
    { commonStore.withHeader &&
      <header className={'header ' + (commonStore.isBugerMenuActive?'active ':' ')}>
        <NoAccountModal />
        <div className='header__inner'>
          <button className="burger" onClick={() => commonStore.setIsBugerMenuActive(!commonStore.isBugerMenuActive)} >
            <span className='bars'><FontAwesomeIcon icon={faBars} /></span>
            <span className='times'><FontAwesomeIcon icon={faTimes} /></span>
          </button>
          <Logo />
          <div className="header__nav">
            <Explore location={location} />
            <a className='header__nav__item' onClick={() => anchorScroll('#cashbackBlock','/')}>{translationStore.translate('header_nav_item_cashback')}</a>
            <a className='header__nav__item' onClick={() => anchorScroll('#traveladvantageBlock','/')}>Reisevorteil</a>
            {(!commonStore.isLoggedIn)?
              (<a className='header__nav__item header__nav__item--mobile' href="/login">
                {/* {translationStore.translate('general_button_login')} */}
                Anmelden
                </a>):''
            }
            {(!commonStore.isLoggedIn)?
              (<a className='header__nav__item header__nav__item--mobile' href="/registration">
                {/* {translationStore.translate('general_button_register')} */}
                Registrieren
                </a>):''
            }
          </div>

          <div className='header__social-top'>
            <div className='header__social-top__inner'>
              { translationStore.translate('general_facebook_link') !== 'general_facebook_link' && 
              <a rel='noopener noreferrer' href={translationStore.translate('general_facebook_link')} target='_blank'>
                  <FontAwesomeIcon icon={faFacebookF} />
              </a>
              }
              { translationStore.translate('general_instagram_link') == 'general_instagram_link' && 
              <a rel='noopener noreferrer' href={translationStore.translate('general_instagram_link')} target='_blank'>
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              }
              { translationStore.translate('general_youtube_link') == 'general_youtube_link' && 
              <a rel='noopener noreferrer' href={translationStore.translate('general_instagram_link')} target='_blank'>
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              }
            </div>
          </div>

          {commonStore.isLoggedIn ?
            <LoggedInHeader />
            :
            <LoggedOffHeader />
          }
          {/* {isLead(location) && <div className='absolute w-full w-full h-full opacity-75 bg-grey' />} */}
        </div>
      </header>
    }
    </React.Fragment>
  )
}

export default inject('commonStore', 'translationStore')(observer(Header))



// WEBPACK FOOTER //
// ./src/components/Header/index.js